<template>
    <div>
        <canvas width="800" height="250"></canvas>

        <change-development-breakdown-modal
                v-if="monthBreakdown"
                :filters="filters"
                :month="monthBreakdown"
        />
    </div>
</template>

<script>
    import datalabels from 'chartjs-plugin-datalabels'
    import Chart from 'chart.js'

    import ChangeDevelopmentBreakdownModal from '@/components/Modals/Dashboard/Subscriptions/ChangeDevelopmentBreakdown'

    export default {
        components: {ChangeDevelopmentBreakdownModal},

        props: ['year', 'metricType', 'rows', 'filters', 'loading'],

        data() {
            return {
                monthBreakdown: null
            }
        },

        mounted() {
            this.$nextTick(this.draw)
        },

        watch: {
            loading() {
                this.$nextTick(this.draw)
            }
        },

        computed: {
            datasets() {
                return [
                    {
                        label: 'Net change',
                        data: this.netChangeColumn,
                        type: 'line',
                        backgroundColor: '#20aaea',
                        borderColor: '#20aaea',
                        fill: false,
                        datalabels: {
                            anchor: 'end',
                            align: 'end',
                            formatter: (value, context) => this.format(value)
                        }
                    },
                    {
                        label: 'New (actual)',
                        data: this.actualNewColumn,
                        backgroundColor: '#62d26f',
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        label: 'New (expected)',
                        data: this.expectedNewColumn,
                        backgroundColor: '#37c5ab',
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        label: 'Renewed',
                        data: this.renewedColumn,
                        backgroundColor: '#a4cf30',
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        label: 'Ending (with renewal)',
                        data: this.endingWithRenewalColumn,
                        backgroundColor: '#eec300',
                        datalabels: {
                            display: false
                        }
                    },
                    {
                        label: 'Ending (without renewal)',
                        data: this.endingWithoutRenewalColumn,
                        backgroundColor: '#e8384f',
                        datalabels: {
                            display: false
                        }
                    }
                ]
            },

            netChangeColumn() {
                return this.rows.reduce((result, row) => {
                    result.push(row.net_change)

                    return result
                }, [])
            },

            actualNewColumn() {
                return this.rows.reduce((result, row) => {
                    result.push(row.actual_new)

                    return result
                }, [])
            },

            expectedNewColumn() {
                return this.rows.reduce((result, row) => {
                    result.push(row.expected_new)

                    return result
                }, [])
            },

            renewedColumn() {
                return this.rows.reduce((result, row) => {
                    result.push(row.renewed)

                    return result
                }, [])
            },

            endingWithRenewalColumn() {
                return this.rows.reduce((result, row) => {
                    result.push(row.ending_with_renewal)

                    return result
                }, [])
            },

            endingWithoutRenewalColumn() {
                return this.rows.reduce((result, row) => {
                    result.push(row.ending_without_renewal)

                    return result
                }, [])
            },
            
            labels() {
                return this.rows.map(row => row.month.format('MMMM'))
            }
        },

        methods: {
            draw() {
                new Chart(this.$el.querySelector('canvas').getContext('2d'), {
                    plugins: [datalabels],

                    type: 'bar',

                    data: {
                        labels: this.labels,
                        datasets: this.datasets
                    },

                    options: {
                        scales: {
                            xAxes: [{
                                stacked: true
                            }],
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true,
                                    callback: (value, context) => this.format(value)
                                }
                            }]
                        },

                        legend: {
                            position: 'bottom'
                        },

                        layout: {
                            padding: {
                                top: 25
                            }
                        },

                        tooltips: {
                            callbacks: {
                                label: (t, d) => {
                                    let dataset = d.datasets[t.datasetIndex]

                                    return dataset.label + ': ' + this.format(dataset.data[t.index])
                                }
                            }
                        },

                        onClick: (event, elements) => {
                            if (elements.length) {
                                this.monthBreakdown = this.rows[elements[0]['_index']].month.format('YYYY-MM-DD')

                                this.$nextTick(() => $('#show-change-development-breakdown-modal').modal('show'))
                            }
                        }
                    }
                });
            },

            format(value) {
                if (this.metricType === 'revenue') {
                    return this.$options.filters.price(value)
                }

                return this.$options.filters.number(value)
            }
        }
    }
</script>
